let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4fw7s")).then(() => parcelRequire('2fH53'));